import { SignalsCreator } from "./signals-creator";
import { VariableUniversalSignalLine, ConstUniversalSignalLine } from "../../../../../../web-visualizator";

export class UniversalSignalsCreator extends SignalsCreator {
  constructor() {
    super();
  }

  _createLine(fullLineType, signalLineSettings) {
    switch (fullLineType) {
      case "variable-isoline-line":
        return new VariableUniversalSignalLine(signalLineSettings);
      case "const-isoline-line":
        return new ConstUniversalSignalLine(signalLineSettings);
    }
    return undefined;
  }
}
